import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'app.components.WxExportApplicantModal.title',
    defaultMessage: 'Create or sync worker profile',
    description:
      'Modal title for synchronizing applicant profiles to worker profiles',
  },
  body: {
    id: 'app.components.WxExportApplicantModal.body',
    defaultMessage:
      'This will create or sync {count} applicant profiles to worker profiles. New applicants will be created as workers, and existing workers will be updated. Depending on your configuration, this may trigger worker profile-related actions, such as onboarding flows and communications.',
    description:
      'Explains that applicant profiles create or update worker profiles and may trigger worker profile actions',
  },
  mainStatus: {
    id: 'app.components.WxExportApplicantModal.mainStatus',
    defaultMessage: 'Main status',
    description:
      'Label for the dropdown that sets the worker employment status applicants get in Onboard',
  },
  secondaryStatus: {
    id: 'app.components.WxExportApplicantModal.secondaryStatus',
    defaultMessage: 'Secondary status',
    description:
      'Label for the dropdown that sets the sub-status under the selected main status',
  },
  created: {
    id: 'app.components.WxExportApplicantModal.created',
    defaultMessage: 'Created',
    description:
      'Main employment status for a worker record that exists but has not entered onboarding',
  },
  preHire: {
    id: 'app.components.WxExportApplicantModal.preHire',
    defaultMessage: 'Pre-hire',
    description:
      'Main employment status for a worker who has accepted an offer and is onboarding',
  },
  active: {
    id: 'app.components.WxExportApplicantModal.active',
    defaultMessage: 'Active',
    description: 'Main employment status for a worker currently working',
  },
  rehire: {
    id: 'app.components.WxExportApplicantModal.rehire',
    defaultMessage: 'Rehire',
    description:
      'Main employment status for a former worker returning to the company',
  },
  inactive: {
    id: 'app.components.WxExportApplicantModal.inactive',
    defaultMessage: 'Inactive',
    description:
      'Main employment status for a worker not currently working but still employed',
  },
  terminated: {
    id: 'app.components.WxExportApplicantModal.terminated',
    defaultMessage: 'Terminated',
    description:
      'Main employment status for a worker whose employment has ended',
  },
  applicant: {
    id: 'app.components.WxExportApplicantModal.applicant',
    defaultMessage: 'Applicant',
    description:
      'Secondary employment status for a worker who has not yet been hired',
  },
  employee: {
    id: 'app.components.WxExportApplicantModal.employee',
    defaultMessage: 'Employee',
    description: 'Secondary employment status for a worker on the payroll',
  },
  leaveOfAbsence: {
    id: 'app.components.WxExportApplicantModal.leaveOfAbsence',
    defaultMessage: 'Leave of Absence',
    description:
      'Secondary employment status for an inactive worker on approved leave',
  },
  suspended: {
    id: 'app.components.WxExportApplicantModal.suspended',
    defaultMessage: 'Suspended',
    description:
      'Secondary employment status for an inactive worker barred from working temporarily',
  },
  seasonal: {
    id: 'app.components.WxExportApplicantModal.seasonal',
    defaultMessage: 'Seasonal',
    description:
      'Secondary employment status for an inactive worker who works only part of the year',
  },
  furloughed: {
    id: 'app.components.WxExportApplicantModal.furloughed',
    defaultMessage: 'Furloughed',
    description:
      'Secondary employment status for an inactive worker on a temporary unpaid layoff',
  },
  resigned: {
    id: 'app.components.WxExportApplicantModal.resigned',
    defaultMessage: 'Resigned',
    description:
      'Secondary employment status for a terminated worker who left voluntarily',
  },
  involuntarySeparation: {
    id: 'app.components.WxExportApplicantModal.involuntarySeparation',
    defaultMessage: 'Involuntary Separation',
    description:
      'Secondary employment status for a terminated worker let go for reasons other than performance or conduct',
  },
  fired: {
    id: 'app.components.WxExportApplicantModal.fired',
    defaultMessage: 'Fired',
    description:
      'Secondary employment status for a terminated worker dismissed for cause',
  },
  archived: {
    id: 'app.components.WxExportApplicantModal.archived',
    defaultMessage: 'Archived',
    description:
      'Secondary employment status for a terminated worker kept only for record keeping',
  },
  send: {
    id: 'app.components.WxExportApplicantModal.sendWebhook',
    defaultMessage: 'Create/sync worker profile',
    description:
      'Confirms synchronizing selected applicant profiles to worker profiles',
  },
  submissionSuccess: {
    id: 'app.components.WxExportApplicantModal.submissionSuccess',
    defaultMessage: 'Successfully submitted applicants for onboarding',
  },
  submissionError: {
    id: 'app.components.WxExportApplicantModal.submissionError',
    defaultMessage:
      'An error occurred while submitting applicants for onboarding',
  },
});
